var React = require('react');

function ArrowRightSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.397 25.426l13.143-11.5-13.143-11.5","strokeWidth":"3","stroke":"#0B0B0A","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRightSmall.defaultProps = {"width":"18","height":"27","viewBox":"0 0 18 27"};

module.exports = ArrowRightSmall;

ArrowRightSmall.default = ArrowRightSmall;
